export default "__VITE_ASSET__f5e91f56__"